import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import NavBarNB from '../../components/NavBarNB';
import FooterNB from '../../components/FooterNB';
import CardNB from '../../components/ui-nb/CardNB';
import IconNB from '../../components/ui-nb/IconNB';

export default function RoleSelectionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading] = useState(false);

  const handleCreateBusiness = () => {
    navigate('/en/setup/create-org');
  };

  const handleJoinBusiness = () => {
    navigate('/en/setup/join-org');
  };

  return (
    <div className="min-h-screen flex flex-col bg-nb-cream">
      <NavBarNB />
      <main className="flex-1 max-w-md mx-auto px-4 py-16 text-center">
        <h1
          className="text-3xl font-bold text-black font-nb mb-4">
          {t('setup.role.title') || 'What are you planning to do on Tellow Up?'}
        </h1>
        <p className="text-lg mb-8 text-nb-text-secondary">
          {t('setup.role.subtitle') || 'Choose how you want to get started'}
        </p>

        <div className="space-y-4">
          {/* Option A: Create business */}
          <CardNB variant="interactive" className="w-full">
            <button
              onClick={handleCreateBusiness}
              disabled={loading}
              className="w-full text-left">
              <div className="flex items-start gap-4">
                <IconNB name="branches" size={40} />
                <div>
                  <h3 className="text-lg font-semibold text-black">
                    {t('setup.role.adminOption') || 'Administer your business'}
                  </h3>
                  <p className="text-sm mt-1 text-nb-text-secondary">
                    {t('setup.role.adminDesc') || 'Start your own repair shop and manage your team'}
                  </p>
                </div>
              </div>
            </button>
          </CardNB>

          {/* Option B: Join business */}
          <CardNB variant="interactive" className="w-full">
            <button
              onClick={handleJoinBusiness}
              disabled={loading}
              className="w-full text-left">
              <div className="flex items-start gap-4">
                <IconNB name="users" size={40} />
                <div>
                  <h3 className="text-lg font-semibold text-black">
                    {t('setup.role.employeeOption') || 'Work for an actual business'}
                  </h3>
                  <p className="text-sm mt-1 text-nb-text-secondary">
                    {t('setup.role.employeeDesc') || "Join an existing team using an invite code"}
                  </p>
                </div>
              </div>
            </button>
          </CardNB>
        </div>

        <p className="mt-8 text-sm text-nb-text-muted">
          {t('setup.role.switchNote') || 'You can change this later'}
        </p>
      </main>
      <FooterNB />
    </div>
  );
}
